import { UserProvider } from "./context/userContext";
import { LanguageProvider } from "./context/languageContext";
import Layout from "./components/layout";

export default function MainLayout({ children }) {
  return (
    <UserProvider>
      <LanguageProvider>
        <Layout>{children}</Layout>
      </LanguageProvider>
    </UserProvider>
  );
}
